<script lang="ts" setup></script>

<template>
  <main class="notfound-main">
    <div class="column side4"></div>

    <div class="column middle">
      <div class="panel mainpanel firstpanel">
        <div class="text-center">
          <pre></pre>
        </div>
        <hr />

        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-10 text-center">
            <h1>500 Internal Server Error</h1>
          </div>
          <div class="col-md-1"></div>
        </div>
      </div>
    </div>

    <div class="column side4"></div>
  </main>
</template>

<style scoped lang="scss">
.notfound-main {
  display: flex;
  width: 100%;
}

.image-404 {
  width: 300px;
}
</style>
